import { render, staticRenderFns } from "./tradesmanChat.vue?vue&type=template&id=2b3b98fc&scoped=true&"
import script from "./tradesmanChat.vue?vue&type=script&lang=js&"
export * from "./tradesmanChat.vue?vue&type=script&lang=js&"
import style0 from "./tradesmanChat.vue?vue&type=style&index=0&id=2b3b98fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3b98fc",
  null
  
)

export default component.exports